<div class="container-fluid mt-4">
  <div class="row">
    <div class="col-xl-12 rowp">
      <div class="d-sm-flex d-block align-items-center mb-4">
        <div class="me-auto d-flex">
          <h2 class="ac-heading">Payment History</h2>
        </div>
        <app-bans-dropdown
          [banCAs]="banCAs"
          [ban]="ban"
          (selectedBAN)="selectBan($event)"
        ></app-bans-dropdown>
      </div>
      <div
        class="col-sm-12 col-md-8 ac-ff-inter fs-12 font-weight-lighter text-black table-actions"
      >
        <p class="d-flex">
          Note: There is $8.95 Service fee is charged in addition to the Amount
          for all the payments done through card.
        </p>
        <div
          (click)="downloadCSV()"
          class="download-button"
          tabindex="0"
          ngbTooltip="Download as CSV"
          [ngClass]="{ disable: paymentHistory.length == 0 }"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            width="27"
            height="27"
            viewBox="0 0 48 48"
          >
            <path
              d="M 23.970703 5.9726562 A 2.0002 2.0002 0 0 0 22 8 L 22 27.171875 L 19.414062 24.585938 A 2.0002 2.0002 0 1 0 16.585938 27.414062 L 22.585938 33.414062 A 2.0002 2.0002 0 0 0 25.414062 33.414062 L 31.414062 27.414062 A 2.0002 2.0002 0 1 0 28.585938 24.585938 L 26 27.171875 L 26 8 A 2.0002 2.0002 0 0 0 23.970703 5.9726562 z M 7.9707031 30.972656 A 2.0002 2.0002 0 0 0 6 33 L 6 36 C 6 39.290032 8.7099679 42 12 42 L 36 42 C 39.290032 42 42 39.290032 42 36 L 42 33 A 2.0002 2.0002 0 1 0 38 33 L 38 36 C 38 37.127968 37.127968 38 36 38 L 12 38 C 10.872032 38 10 37.127968 10 36 L 10 33 A 2.0002 2.0002 0 0 0 7.9707031 30.972656 z"
            ></path>
          </svg>
        </div>
      </div>
    </div>

    <div class="col-lg-12 mt-3">
      <div class="table-responsive fs-14">
        <table
          class="table mb-4 dataTable table-striped-custom table-bordered-custom"
          id="example5"
        >
          <thead class="ac-btb">
            <tr>
              <th
                class=""
                scope="col"
                sortable="banNo"
                (sort)="onSort($any($event))"
              >
                Account No.
                <span class="material-icons ac-arrow-up">arrow_drop_up</span>
                <span class="material-icons">arrow_drop_down</span>
              </th>

              <th
                class=""
                scope="col"
                sortable="transactionId"
                (sort)="onSort($any($event))"
              >
                Transaction ID
                <span class="material-icons ac-arrow-up">arrow_drop_up</span>
                <span class="material-icons">arrow_drop_down</span>
              </th>

              <th
                class=""
                scope="col"
                sortable="amount"
                (sort)="onSort($any($event))"
              >
                Amount
                <span class="material-icons ac-arrow-up">arrow_drop_up</span>
                <span class="material-icons">arrow_drop_down</span>
              </th>

              <th
                class=""
                scope="col"
                sortable="paymentDate"
                (sort)="onSort($any($event))"
              >
                Payment Date
                <span class="material-icons ac-arrow-up">arrow_drop_up</span>
                <span class="material-icons">arrow_drop_down</span>
              </th>
              <th
                class=""
                scope="col"
              >
                Payment Method
              </th>
            </tr>
          </thead>
          <tbody class="ac-rowhov">
            <ng-container *ngFor="let data of paymentHistory; let i = index">
              <tr
                class="ac-table-hover-row"
                (click)="openPaymentDetails(data)"
                [ngClass]="{
                  'payment-info-visible':
                    selectedPaymentData &&
                    selectedPaymentData.transactionId == data.transactionId
                }"
              >
                <td>
                  <span class="text-black font-w500 ac-invoice-num">{{
                    data.banNo
                  }}</span>
                </td>
                <td>
                  <span class="text-black font-w500 ac-invoice-num">{{
                    data.transactionId
                  }}</span>
                </td>
                <td>
                  <span class="text-black"
                    ><span class="font-w600">{{
                      data.currency | currencySymbol
                    }}</span
                    >{{ data.amount | number : "1.2-2" }}</span
                  >
                </td>
                <td>
                  <span class="text-black">{{ data.paymentDate }}</span>
                </td>
                <td>
                  <span class="text-black text-nowrap">{{
                    data.paymentType
                  }}</span>
                </td>
              </tr>
              <tr
                *ngIf="
                  selectedPaymentData &&
                  selectedPaymentData.transactionId == data.transactionId
                "
                class="payment-information"
              >
                <ng-container *ngIf="!showPMInfoLoader">
                  <td>
                    <div class="payment-details">
                      <label for="">Payment Status</label>
                      <span>{{ selectedPaymentData.paymentStatus }}</span>
                    </div>
                  </td>
                  <td>
                    <div class="payment-details">
                      <label for="">Payment Method Type</label>
                      <span>{{ selectedPaymentData.paymentType }}</span>
                    </div>
                  </td>
                  <td>
                    <div class="payment-details">
                      <label for="">{{
                        selectedPaymentData.paymentType == "CARD PAYMENT"
                          ? "Card Number"
                          : "Account Number"
                      }}</label>
                      <span>{{ formatPaymentData(selectedPaymentData.paymentMethod) }}</span>
                    </div>
                  </td>
                  <td>
                    <div class="payment-details">
                      <label for="">Amount</label>
                      <span class="text-black"
                        ><span class="font-w600">{{
                          data.currency | currencySymbol
                        }}</span
                        >{{
                          selectedPaymentData.amount | number : "1.2-2"
                        }}<span *ngIf="selectedPaymentData.paymentType == 'CARD PAYMENT' && !isSledCustomer">{{" + $8.95 Service Fee"}}</span></span>
                    </div>
                  </td>
                  <td>
                    <div class="payment-details">
                      <label for="">Total Amount</label>
                      <span class="text-black"
                        ><span class="font-w600">{{
                          data.currency | currencySymbol
                        }}</span
                        >{{
                          selectedPaymentData.totalAmount | number : "1.2-2"
                        }}</span
                      >
                    </div>
                  </td>
                </ng-container>
                <ng-container *ngIf="showPMInfoLoader">
                  <td id="ban-dropdown-loader" class="api-loader">
                    <span>Loading Details</span
                    ><svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 200 200"
                    >
                      <circle
                        fill="#070103"
                        stroke="#070103"
                        stroke-width="6"
                        r="15"
                        cx="40"
                        cy="100"
                      >
                        <animate
                          attributeName="opacity"
                          calcMode="spline"
                          dur="1.3"
                          values="1;0;1;"
                          keySplines=".5 0 .5 1;.5 0 .5 1"
                          repeatCount="indefinite"
                          begin="-.4"
                        ></animate>
                      </circle>
                      <circle
                        fill="#070103"
                        stroke="#070103"
                        stroke-width="6"
                        r="15"
                        cx="100"
                        cy="100"
                      >
                        <animate
                          attributeName="opacity"
                          calcMode="spline"
                          dur="1.3"
                          values="1;0;1;"
                          keySplines=".5 0 .5 1;.5 0 .5 1"
                          repeatCount="indefinite"
                          begin="-.2"
                        ></animate>
                      </circle>
                      <circle
                        fill="#070103"
                        stroke="#070103"
                        stroke-width="6"
                        r="15"
                        cx="160"
                        cy="100"
                      >
                        <animate
                          attributeName="opacity"
                          calcMode="spline"
                          dur="1.3"
                          values="1;0;1;"
                          keySplines=".5 0 .5 1;.5 0 .5 1"
                          repeatCount="indefinite"
                          begin="0"
                        ></animate>
                      </circle>
                    </svg>
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </ng-container>
              </tr>
            </ng-container>
            <tr
              *ngIf="
                !banflag && paymentHistory.length == 0 && !unSupportedBanPM
              "
            >
              <td colspan="12" class="text-center mt-2 p-2">
                <article>
                  <div class="line"></div>
                  <div class="line"></div>
                  <div class="line"></div>
                  <div class="line"></div>
                  <div class="line"></div>
                  <div class="line"></div>
                  <div class="line"></div>
                  <div class="shimmer"></div>
                </article>
              </td>
            </tr>

            <tr
              *ngIf="
                unSupportedBanPM || (banflag && paymentHistory.length == 0)
              "
            >
              <td colspan="12" class="no-data-message text-center">
                <svg
                  width="290"
                  height="271"
                  viewBox="0 0 290 271"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_2900_300109)">
                    <path
                      opacity="0.2"
                      d="M176.31 139.716C140.224 153.717 99.5914 135.862 85.5613 99.8244C71.5313 63.7871 89.4293 23.2174 125.515 9.21688C161.609 -4.7913 202.242 13.0636 216.272 49.1086C230.302 85.1459 212.404 125.716 176.31 139.716Z"
                      fill="#D9D9D9"
                    />
                    <path
                      opacity="0.1"
                      d="M163.623 5.61405L108.632 130.317C107.785 129.677 106.946 129.014 106.122 128.336C100.881 124.009 96.2426 118.883 92.3975 113.041L139.889 5.33221C147.877 4.04489 155.903 4.18962 163.623 5.62167V5.61405Z"
                      fill="white"
                    />
                    <path
                      opacity="0.1"
                      d="M202.715 27.2545L151.013 144.484C140.179 144.5 129.582 141.994 120.038 137.309L176.494 9.29297C186.404 13.1625 195.407 19.2716 202.715 27.2545Z"
                      fill="white"
                    />
                    <path
                      d="M93.206 27.308C119.29 -4.51695 166.278 -9.20158 198.153 16.8419C230.028 42.8854 234.719 89.8002 208.635 121.625C182.544 153.458 135.556 158.142 103.681 132.099C71.8062 106.056 67.1142 59.1407 93.206 27.308ZM203.921 117.771C227.868 88.551 223.566 45.4677 194.292 21.5494C165.019 -2.36888 121.876 1.9425 97.9208 31.1624C73.9652 60.3899 78.2681 103.473 107.541 127.392C136.814 151.31 179.957 146.998 203.921 117.771Z"
                      fill="#D9D9D9"
                    />
                    <path
                      d="M210.497 117.512C217.844 121.892 224.832 126.706 231.698 131.672C238.565 136.639 245.255 141.819 251.847 147.12C258.439 152.422 264.893 157.891 271.126 163.627C274.246 166.491 277.306 169.431 280.304 172.448C283.294 175.472 286.239 178.549 289.001 181.847C290.527 183.66 290.283 186.372 288.467 187.888C287.078 189.053 285.156 189.183 283.653 188.368C279.869 186.311 276.268 184.041 272.705 181.71C269.15 179.372 265.656 176.965 262.23 174.474C255.364 169.507 248.719 164.274 242.211 158.874C235.704 153.473 229.295 147.95 223.062 142.215C216.829 136.479 210.718 130.591 204.966 124.268C203.325 122.463 203.455 119.675 205.263 118.03C206.736 116.689 208.872 116.537 210.505 117.504L210.497 117.512Z"
                      fill="#D9D9D9"
                    />
                    <path
                      d="M172.518 128.793C173.838 125.083 177.546 122.448 181.452 122.448H242.524C247.155 122.448 250.473 126.112 249.939 130.621L234.17 262.819C233.628 267.336 229.44 270.992 224.801 270.992H30.9973C26.3664 270.992 23.0477 267.328 23.5818 262.819L36.826 151.774C37.3677 147.257 41.5561 143.601 46.1946 143.601H151.653C160.785 143.601 169.436 137.454 172.518 128.785V128.793Z"
                      fill="#D9D9D9"
                    />
                    <path
                      d="M27.0986 264.914H229.577L241.12 128.884H38.6339L27.0986 264.914Z"
                      fill="#F5F5F5"
                    />
                    <path
                      d="M27.0986 264.914H229.577L237.931 128.884H38.6339L27.0986 264.914Z"
                      fill="#EEEEEE"
                    />
                    <path
                      d="M27.0986 264.914H229.577L236.542 124.565H34.0564L27.0986 264.914Z"
                      fill="#F5F5F5"
                    />
                    <path
                      d="M27.0986 264.914H229.577L232.331 124.565H34.0564L27.0986 264.914Z"
                      fill="#EEEEEE"
                    />
                    <path
                      d="M27.0986 264.914H229.577L230.782 120.757H28.304L27.0986 264.914Z"
                      fill="#F5F5F5"
                    />
                    <path
                      d="M27.0984 264.914H229.577L225.426 123.484H24.2451L27.0984 264.914Z"
                      fill="#EEEEEE"
                    />
                    <path
                      d="M27.0987 264.914H229.577L223.573 124.565H21.0869L27.0987 264.914Z"
                      fill="#F5F5F5"
                    />
                    <path
                      d="M27.0982 264.914H229.576L220.009 126.683H17.5312L27.0982 264.914Z"
                      fill="#EEEEEE"
                    />
                    <path
                      d="M27.0987 264.914H229.577L218.484 127.864H16.0059L27.0987 264.914Z"
                      fill="#F5F5F5"
                    />
                    <path
                      d="M128.498 137.378C128.627 133.577 131.496 130.88 135.402 130.88H196.474C201.105 130.88 205.598 134.628 206.498 139.259L230.622 262.629C231.53 267.253 228.501 271.008 223.87 271.008H30.0738C25.4429 271.008 20.9493 267.26 20.0491 262.629L0.15983 160.931C-0.748041 156.307 2.28074 152.552 6.91165 152.552H112.37C121.502 152.552 128.185 146.26 128.498 137.37V137.378Z"
                      fill="#D9D9D9"
                    />
                    <path
                      opacity="0.2"
                      d="M128.498 137.378C128.627 133.577 131.496 130.88 135.402 130.88H196.474C201.105 130.88 205.598 134.628 206.498 139.259L230.622 262.629C231.53 267.253 228.501 271.008 223.87 271.008H30.0738C25.4429 271.008 20.9493 267.26 20.0491 262.629L0.15983 160.931C-0.748041 156.307 2.28074 152.552 6.91165 152.552H112.37C121.502 152.552 128.185 146.26 128.498 137.37V137.378Z"
                      fill="white"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_2900_300109">
                      <rect width="290" height="271" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                <div class="mt-3 nodata"><b>No Data Available Yet!</b></div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div
    class="col-12 ac-ff-inter fs-12 font-weight-lighter mt-4 rowp-f d-flex justify-content-center"
  >
    <button
      *ngIf="!isAllPaymentHistoryLoaded"
      class="btn ac-btn-primary mb-sm-0 mb-2 w-50"
      (click)="loadMorePaymentHistory()"
      style="font-size: 18px"
    >
      Load More...
    </button>
  </div>
  <div class="col-12 ac-ff-inter fs-12 font-weight-lighter mt-4 rowp-f">
    <p>
      *It may take up to 24 hours for this page to reflect a recent payment.
    </p>
  </div>
</div>
<app-reusable-error-component
  #errorPopup
  [instructionText]="instructionTextForPopup"
></app-reusable-error-component>
